import CommonCss from "nlib/common/common.module.scss";

import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AutoTooltip from "nlib/ui/AutoTooltip";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import React from "react";

const MAX_VISIBLE_DESCRIPTION_LENGTH = 200;

const DescriptionCell = ({ documentData }) => {
  const {
    status,
    lineItems,
    attachment,
    lastExportErrors,
    recogniseData: { status: recogniseStatus }
  } = documentData;

  const { uiTexts, errors } = useSelector(getTextsData);

  if ((status === DataStatuses.TO_REVIEW) && lastExportErrors?.length) {
    return (
      <AutoTooltip className={CommonCss.negativeText}>
        <Icons.Warning weight="bold" className={Css.errorIcon} />
        <span><b>{`${errors.exportDocumentError}: ${lastExportErrors.join("; ")}`}</b></span>
      </AutoTooltip>
    );
  }

  const extractStatus = status === DataStatuses.TO_EXTRACT;

  const errorState = recogniseStatus === DocumentRecogniseStatuses.ERROR;

  if (extractStatus && errorState) {
    return (
      <AutoTooltip className={CommonCss.negativeText}>
        <span><b>{errors.ocrError}</b></span>
      </AutoTooltip>
    );
  }

  const fileName = attachment?.originalName;

  const uniqueDescriptions = lineItems
    ? [...new Set(lineItems.map(({ description = "" }) => description.trim()).filter(Boolean))] : [];

  let content = extractStatus
    ? uiTexts.processing
    : uniqueDescriptions.join(", ");

  if (extractStatus && fileName) content = `${content}: ${fileName}`;
  if (content.length > MAX_VISIBLE_DESCRIPTION_LENGTH) {
    content = `${content.slice(0, MAX_VISIBLE_DESCRIPTION_LENGTH)}...`;
  }

  return (
    <AutoTooltip active={!!content}>
      {content || Constants.EMPTY_PLACEHOLDER}
    </AutoTooltip>
  );
};

export default React.memo(DescriptionCell);
